'use strict';
var $ = require('jquery');

$(function() {

    $('.caps-nord').each(function(index, obj) {
        if($(this).text().startsWith('NORD')){
            var newstring = $(this).text().substring(4);
            $(this).text(newstring);
            $(this).prepend('<span class="black">NORD</span>');
        }
    });
    function span_after_space(){
        if($('.span-after-space').length > 0){
            $('.span-after-space').html(function(){	
                var text= $(this).text().split(' ');
                var last = text.pop();
                return text.join(" ") + (text.length > 0 ? ' <span class="surname">'+last+'</span>' : last);   
            });
        }
    }
    span_after_space();


    $('button.table-button').on('click', function(){

        $('.table-button').addClass('inactive');
        $(this).removeClass('inactive');

        const activeTab = $(this).data('tablebutton');

        $(`.downlaod-table`).addClass('hide');
        $(`.${activeTab}`).removeClass('hide');

    });


    if($('.download-table-row').length > 0){
        $('.download-table-row').slice(3).hide();
    }
    $('.show-more').on('click', function(){

        // Hide
        if($(this).hasClass('active')) {
            $('.download-table-row').each(function() {
                $('.download-table-row').slice(3).hide();
            });
            $('.downlaod-table').find('table').removeClass('active');
            $(this).removeClass('active');
            $(this).text($(this).attr('data_visible'));
        } else { // Show
            $('.downlaod-table').find('table').addClass('active');
            $(this).addClass('active');
            $(this).text($(this).attr('data_hidden'));
            $('.download-table-row').slice(3).show();


        }
    });

    $('.checkbox-download-file').on('click', function(){
        $(this).toggleClass('selected');
       var selectedCount = $('.checkbox-download-file:checked').length;
        var download_button = document.getElementById("download_selected_files");


        if (selectedCount > 0) {
           download_button.classList.remove('notselected');
           download_button.disabled = false;
           $('#selected_count').text("(" + selectedCount + ")");
        } else {
            download_button.disabled = true;
            download_button.classList.add('notselected');
           $('#selected_count').text("(0)");

        }
    });

    var acc = document.getElementsByClassName("accordion");
    var i;
    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
            } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
            } 
        });
    }

    $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null) {
           return null;
        }
        return decodeURI(results[1]) || 0;
    }
    var prodsearch = $.urlParam('post_type');
    searchlogic();
    function searchlogic() {
        if($('.products-filter').length > 0){
            if(prodsearch == 'products'){
                $('.products-filter').addClass('show');
                $('.search-hidden').val('products');
            }else{
                $('.products-filter').removeClass('show');
            }
        }
    }
    $('.products-filter').on('click', function(){
        $('.search-hidden').val('');
        $('.products-filter').removeClass('show');
    });

    
    
    



    const labels = typeof showmore_vars !== 'undefined' ? showmore_vars : {
        read_more: 'Read more',
        close: 'Close'
    };

    $('.showmore-toggle-btn').on('click', function (e) {
        e.preventDefault();

        const $btn = $(this);
        const $target = $($btn.data('target'));

        $target.stop(true, true).slideToggle(200, function () {
            const isVisible = $target.is(':visible');
            $btn
                .text(isVisible ? labels.close : labels.read_more)
                .toggleClass('is-open', isVisible);
        });
    });


    

});
